import 'core-js/modules/es.array.from.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.array.map.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.string.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import { jsx } from 'react/jsx-runtime';
import { Flex } from '../../flex/flex.js';
import 'core-js/modules/es.object.assign.js';
import 'tslib';
import { Text } from './text.js';

/**
 * Paragraph
 * =========
 * Creates a skeleton that looks like a text or paragraph
 *
 * -----------------------------------------------------------------------------
 *
 * @param  lines - Amount of lines to be rendered
 *
 * -----------------------------------------------------------------------------
 *
 * @example
 * ```
 *   <Skeleton.Paragraph lines={3} />
 * ```
 */
var Paragraph = function Paragraph(_ref) {
  var _ref$lines = _ref.lines,
    lines = _ref$lines === undefined ? 1 : _ref$lines;
  var linesArr = Array.from(Array(lines).keys());
  return jsx(Flex, {
    direction: "column",
    children: linesArr.map(function (lineNum) {
      return jsx(Text, {
        "data-testid": "paragraph",
        currentLine: lineNum,
        isOnlyLine: linesArr.length === 1,
        isLastLine: linesArr.length === lineNum + 1
      }, "line-" + lineNum);
    })
  });
};

export { Paragraph };
